export const web3Seeder = "https://data-seed-prebsc-2-s3.binance.org:8545";
export const web3SeederMain = "https://api.avax.network/ext/bc/C/rpc";

export const web3SeederETH =
  "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161";
// export const web3SeederETH = "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161"
